// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox-module__Checkbox___xKQsQ","error":"Checkbox-module__error___2WZ7W"};